const no = {
  meta: {
    home: { title: "Centauros — Få betalt uten å jage kunder", description: "Definer betalingspolicyer, automatiser påminnelser, generer fakturaer og få betalt uten å jage noen. Alt fra mobilen." },
    privacy: { title: "Personvernerklæring — Centauros", description: "Hvordan Centauros beskytter og behandler dataene dine." },
    terms: { title: "Vilkår for bruk — Centauros", description: "Vilkår for å bruke Centauros." },
    support: { title: "Støtte — Centauros", description: "Hjelp og svar om Centauros." },
    contact: { title: "Kontakt — Centauros", description: "Snakk med Centauros-teamet." },
  },
  nav: { features: "Funksjoner", how: "Slik fungerer det", faq: "FAQ", contact: "Kontakt", download: "Last ned", dashboard: "Panel" },
  hero: {"line1": "Å få betalt burde ikke", "line2": "være enda en jobb.", "subtitle": "Sett reglene fra starten, automatiser oppfølgingen og slutt å jage kundene dine for å få betalt.", "functional": "Med Centauros definerer du betalingspolicyer, automatiserer påminnelser, genererer fakturaer og holder hver betaling under kontroll.", "ctaPrimary": "Last ned Centauros", "ctaSecondary": "Se hvordan det fungerer", "note": "Ingen skjulte gebyrer · Sikre betalinger med Stripe", "availability": "Tilgjengelig for iPhone og Android"},
  marquee: ["Laget for hesteprofesjonelle", "Sikkert", "Raskt", "Pålitelig", "Få betalt uten å jage"],
  problem: {"label": "Problemet", "title": "Å få betalt er problemet. Godt arbeid er ikke nok hvis innkreving blir enda en jobb.", "intro": "Du får betalt sent, jager kundene dine og legger ut tid, materialer og penger. Dette er de reelle kostnadene.", "chapters": [{"n": "01", "title": "Betalinger som kommer sent", "text": "Du ender opp med å finansiere kunden med din egen tid og dine penger."}, {"n": "02", "title": "Jage kunder", "text": "Ubehagelige meldinger, samtaler og e-poster som burde kunne unngås."}, {"n": "03", "title": "Uklare regler", "text": "Når vilkårene ikke settes fra start, skaper det konflikt å kreve senere."}, {"n": "04", "title": "Manglende betaling uten oversikt", "text": "Å ikke vite hva du krever inn, når, eller hva som er forfalt."}, {"n": "05", "title": "Alternativkostnad", "text": "Hver time med å purre er en time mindre til arbeid eller nye kunder."}]},
  solution: {
    label: "Løsningen",
    title: "Centauros automatiserer innkrevingen, fra start til slutt.",
    subtitle: "Sett opp én gang. La det jobbe for deg.",
    items: ["Betalingspolicyer", "Påminnelser", "Fakturaer", "Betalinger", "Oppfølging", "Avstemming"],
    footer: "Alt fra mobilen.",
  },
  how: {
    label: "Slik fungerer det",
    title: "Fire steg. Null friksjon.",
    steps: [
      { title: "Opprett kunde", text: "Legg til kunden din på sekunder." },
      { title: "Velg policy", text: "Bestem når og hvordan det kreves inn automatisk." },
      { title: "Send", text: "Centauros utsteder og sender fakturaen for deg." },
      { title: "Få betalt", text: "Betalingen kommer av seg selv. Uten manuelle påminnelser." },
    ],
  },
  screens: {
    label: "Skjermer",
    title: "Designet med besettelse for detaljer.",
    subtitle: "Hver skjerm bygget for å gjøre innkreving usynlig.",
    items: [
      { title: "Innkreving", text: "Alt du har krav på, med ett blikk." },
      { title: "Policyer", text: "Tydelige, gjenbrukbare betalingsregler." },
      { title: "Fakturaer", text: "Generer og send med ett trykk." },
      { title: "Betalinger", text: "Sikre, med Stripe, i sanntid." },
    ],
  },
  features: {
    label: "Funksjoner",
    title: "Alt du trenger for å få bedre betalt.",
    cards: [
      { title: "Full kontroll", text: "Et klart bilde av hver betaling og kunde." },
      { title: "Automatisering", text: "Repetitive oppgaver kjører av seg selv." },
      { title: "Fakturering", text: "Profesjonelle fakturaer generert umiddelbart." },
      { title: "Innkreving", text: "Automatiske betalinger etter dine policyer." },
      { title: "Team", text: "Inviter teamet ditt og jobb sammen." },
      { title: "Sikkerhet", text: "Sikker infrastruktur og beskyttede data." },
      { title: "Betalinger", text: "Få betalt med kort trygt via Stripe." },
      { title: "Historikk", text: "Hver bevegelse logget og avstemt." },
    ],
  },
  audience: {
    label: "For hvem",
    title: "Laget for dem som lever av arbeidet sitt.",
    subtitle: "Hvis tiden din teller, er Centauros for deg.",
    roles: ["Veterinærer", "Hovslagere", "Trenere", "Transportører", "Hesteprofesjonelle"],
    note: "Og enhver profesjonell som vil få bedre betalt.",
  },
  security: {
    label: "Sikkerhet",
    title: "Pengene og dataene dine, beskyttet.",
    subtitle: "Bygget på pålitelig infrastruktur.",
    points: [
      { title: "Betalinger med Stripe", text: "Vi behandler betalinger med bransjens ledende standard." },
      { title: "Sikker infrastruktur", text: "Kryptering under overføring og i hvile." },
      { title: "Personvern", text: "Dataene dine er dine. Vi selger dem aldri." },
      { title: "Databeskyttelse", text: "Etterlevelse og beste praksis by design." },
      { title: "Ingen lagrede kort", text: "Vi lagrer aldri kortopplysninger." },
    ],
  },
  faq: {
    label: "Ofte stilte spørsmål",
    title: "Alt du vil vite.",
    items: [
      { q: "Hva er Centauros?", a: "En app for å definere betalingspolicyer, automatisere påminnelser, generere fakturaer og få betalt uten å jage noen." },
      { q: "Trenger jeg teknisk kunnskap?", a: "Nei. Det settes opp på minutter og fungerer fra mobilen." },
      { q: "Hvordan behandles betalinger?", a: "Betalinger behandles trygt via Stripe." },
      { q: "Lagrer dere kortopplysningene mine?", a: "Aldri. Vi lagrer ingen kortopplysninger på noe tidspunkt." },
      { q: "Kan jeg automatisere påminnelser?", a: "Ja. Definer policyen én gang, så tar Centauros seg av resten." },
      { q: "Kan jeg generere fakturaer?", a: "Ja, profesjonelle fakturaer umiddelbart, klare til å sendes." },
      { q: "Fungerer det for yrket mitt?", a: "Bygget for hesteprofesjonelle og alle som vil få bedre betalt." },
      { q: "Kan jeg jobbe med teamet mitt?", a: "Ja, du kan invitere teamet ditt og samarbeide." },
      { q: "Er det tilgjengelig på flere språk?", a: "Ja, Centauros er tilgjengelig på 12 språk." },
      { q: "Hvor kan jeg laste det ned?", a: "Snart i App Store for iPhone." },
    ],
  },
  finalCta: { title: "Start i dag.", subtitle: "Last ned Centauros og slutt å jage kunder.", badge: "Last ned i App Store" },
  footer: {
    statement1: "Å få betalt er ikke lenger",
    statement2: "enda en jobb.",
    download: "Last ned Centauros",
    secure: "Sikre betalinger",
    tagline: "Få betalt uten å jage kunder.",
    colProduct: "Produkt", colCompany: "Selskap", colLegal: "Juridisk",
    links: { home: "Hjem", features: "Funksjoner", faq: "FAQ", contact: "Kontakt", privacy: "Personvern", terms: "Vilkår", support: "Støtte", download: "Last ned" },
    contactLabel: "Kontakt",
    rights: "© Centauros. Alle rettigheter forbeholdt.",
  },
  contact: {
    title: "La oss snakke.",
    subtitle: "Har du et spørsmål eller vil vite mer? Skriv til oss.",
    fields: { name: "Navn", email: "E-post", subject: "Emne", message: "Melding" },
    placeholders: { name: "Navnet ditt", email: "du@email.com", subject: "Hvordan kan vi hjelpe?", message: "Fortell oss..." },
    submit: "Send melding", sending: "Sender...", success: "Melding sendt. Vi svarer snart.", error: "Kunne ikke sende. Prøv igjen.", directLabel: "Eller skriv direkte til oss på",
  },
  legal: {
    privacy: {
      title: "Personvernerklæring", updated: "Sist oppdatert: juni 2026",
      body: [
        { h: "Introduksjon", p: "Hos Centauros tar vi personvernet ditt på alvor. Denne erklæringen forklarer hvilke data vi behandler og hvorfor." },
        { h: "Data vi behandler", p: "Vi behandler dataene som trengs for tjenesten: kontoen din, kundene du håndterer og betalingene du gjør." },
        { h: "Betalinger", p: "Betalinger går via Stripe. Vi lagrer aldri dine eller kundenes kortopplysninger." },
        { h: "Bruk av data", p: "Vi bruker dataene dine bare til å levere og forbedre tjenesten. Vi selger aldri informasjonen din." },
        { h: "Dine rettigheter", p: "Du kan når som helst få tilgang til, rette eller slette dataene dine via support@centauros.app." },
      ],
    },
    terms: {
      title: "Vilkår for bruk", updated: "Sist oppdatert: juni 2026",
      body: [
        { h: "Aksept", p: "Ved å bruke Centauros aksepterer du disse vilkårene. Er du uenig, ikke bruk tjenesten." },
        { h: "Bruk av tjenesten", p: "Du forplikter deg til å bruke Centauros lovlig og holde kontoen din trygg." },
        { h: "Betalinger", p: "Betalinger behandles via Stripe etter deres vilkår. Du er ansvarlig for kunderelasjonene dine." },
        { h: "Ansvar", p: "Centauros leveres \"som den er\". Vi jobber for kontinuerlig tilgjengelighet og sikkerhet." },
        { h: "Endringer", p: "Vi kan oppdatere disse vilkårene. Relevante endringer varsles via appen." },
      ],
    },
    support: {
      title: "Støtte", updated: "Vi er her for å hjelpe.",
      intro: "Finn raske svar eller kontakt oss direkte. Vi svarer så raskt som mulig.",
      faqs: [
        { q: "Hvordan kommer jeg i gang?", a: "Last ned appen, opprett kontoen din og legg til din første kunde på minutter." },
        { q: "Hvordan automatiserer jeg innkreving?", a: "Opprett en betalingspolicy og tildel den til kundene dine. Resten er automatisk." },
        { q: "Jeg har et betalingsproblem?", a: "Skriv til support@centauros.app, så ser vi på det sammen." },
        { q: "Kan jeg eksportere dataene mine?", a: "Ja, du kan be om en eksport når som helst." },
      ],
      contactLine: "Trenger du mer hjelp? Skriv til oss på",
    },
  },
  common: { languageLabel: "Språk", backHome: "Tilbake til forsiden", loading: "Laster..." },
  philosophy: {"label": "Filosofien", "title": "Betalingsreglene settes", "titleGreen": "før du begynner.", "text": "Noen ganger er det bedre å si nei til en kunde enn å ta en som tvinger deg til å legge ut tid, penger og ressurser uten å vite når du får betalt. Med Centauros avtaler du fra starten hvordan, når og hvor mye som skal betales.", "points": ["Definere betalingspolicyer", "Forebygge problemer", "Sikre forpliktelser", "Automatisere oppfølging", "Beholde økonomisk kontroll", "Redusere friksjon med kunden"]},
  showcase: {"label": 'Produktet', "slides": [{"id": "control", "title": "Kontroller alt", "green": "du skal kreve inn", "text": "Et klart bilde av hver betaling og virksomheten din, alltid for hånden."}, {"id": "policies", "title": "Du bestemmer", "green": "hvordan og når du får betalt", "text": "På forhånd, depositum + rest, ved fullføring eller gjentakende. Velg riktig policy."}, {"id": "clients", "title": "Hver kunde,", "green": "all informasjonen du trenger", "text": "Data, betalinger, abonnementer og historikk på ett sted."}, {"id": "payments", "title": "Hver betaling,", "green": "under kontroll", "text": "Sanntidsstatus, automatiske påminnelser og faktura umiddelbart."}, {"id": "impagos", "title": "Oppdag manglende betaling", "green": "før den vokser", "text": "Centauros følger opp, purrer og hjelper deg å inndrive det forfalte."}, {"id": "facturacion", "title": "Betalinger og fakturaer", "green": "alltid avstemt", "text": "Utsted, gjennomgå og avstem alle fakturaene dine fra ett sted."}, {"id": "equipo", "title": "Teamet ditt,", "green": "alt under kontroll", "text": "Inviter teamet, tildel roller og håndter innkrevingen sammen."}]},
  badges: {"appStoreTop": "Last ned på", "appStoreLabel": "App Store", "playTop": "Få den på", "playLabel": "Google Play"},
  partners: {"label": "Drevet av ledende betalingspartnere"},
  dashboard: {
    loginTitle: "Centauros-panel", loginSubtitle: "Privat admintilgang.",
    email: "E-post", password: "Passord", signIn: "Logg inn", signingIn: "Logger inn...", invalid: "Ugyldige opplysninger.", logout: "Logg ut",
    nav: { overview: "Oversikt", users: "Brukere", workspaces: "Arbeidsområder", activity: "Aktivitet", incidents: "Hendelser" },
    metrics: { users: "Totale brukere", active: "Aktive brukere", workspaces: "Arbeidsområder", incidents: "Åpne hendelser", collected: "Totalt innkrevd" },
    tableUsers: { name: "Navn", email: "E-post", profession: "Yrke", status: "Status" },
    tableWorkspaces: { name: "Arbeidsområde", members: "Medlemmer", plan: "Plan", collected: "Innkrevd" },
    tableIncidents: { title: "Tittel", workspace: "Arbeidsområde", severity: "Alvor", status: "Status" },
    recentActivity: "Nylig aktivitet",
  },
  policies: {
    label: "Betalingsregler",
    title: "Du bestemmer hvordan og når du får betalt.",
    subtitle: "Velg regelen som passer for hver kunde, så bruker Centauros den automatisk.",
    methods: [
      { name: "Forskuddsbetaling", desc: "Krev inn hele beløpet før du starter. Null risiko." },
      { name: "Depositum + restbeløp", desc: "Et depositum nå og resten når jobben er ferdig." },
      { name: "Betaling ved fullføring", desc: "Kunden betaler automatisk når du er ferdig." },
      { name: "Gjentakende betaling", desc: "Abonnementer og avgifter som trekkes automatisk hver periode." },
      { name: "Senere ekstra", desc: "Legg til ekstra kostnader etter tjenesten, helt uten friksjon." },
      { name: "Betaling per milepæl", desc: "Del betalingen i faser og få betalt underveis." },
    ],
    ui: { upfront: "Forskudd", paid: "Betalt", pending: "Venter", total: "Totalt", deposit: "Depositum", balance: "Restbeløp", completed: "Fullført", dueOnFinish: "Ved fullføring", monthly: "Månedlig", nextCharge: "Neste trekk", extra: "Ekstra", milestone: "Milepæl" },
  },
  redesign: { comingSoon: "Kommer snart" },
  appui: { hello: "Hei", toCollect: "Til innkreving", collected: "Mottatt", overdue: "Forfalt", activity: "Aktivitet", pending: "Venter", paid: "Betalt", advance: "Forskudd", extra: "Ekstra", payNow: "Betal nå" },
  faqx: [
    { q: "Hva er Centauros?", a: "Centauros er en plattform for å definere betalingsregler, automatisere betalinger, generere fakturaer og redusere manglende betaling uten å jage kundene dine. Du setter reglene én gang, og appen krever inn, minner om og avstemmer for deg." },
    { q: "Hvem er det for?", a: "For enhver profesjonell eller bedrift som fakturerer for tjenestene sine: trenere, veterinærer, advokater, konsulenter, byråer, klinikker, treningssentre eller tjenestebedrifter. Enten du fakturerer gjentakende eller per prosjekt, tilpasser Centauros seg måten du jobber på." },
    { q: "Må kundene mine installere appen?", a: "Nei. Kundene dine mottar betalingslenker og meldinger direkte, uten å laste ned noe. Bare du, den profesjonelle, bruker Centauros-appen." },
    { q: "Hvilke betalingsmetoder kan jeg godta?", a: "Takket være Stripe kan du godta kreditt- og debetkort, Apple Pay, Google Pay og de øvrige metodene som er tilgjengelige i landet ditt. De konkrete metodene avhenger av Stripes dekning i hver region." },
    { q: "Kan jeg bestemme hvordan og når jeg får betalt?", a: "Ja. Forskuddsbetaling, depositum + restbeløp, betaling ved fullføring, gjentakende betalinger, senere ekstra eller betaling per milepæl. Du velger regelen som passer for hver kunde eller tjeneste." },
    { q: "Genererer Centauros fakturaer automatisk?", a: "Ja. Det kan lage utkast, utstede fakturaer automatisk etter betaling eller følge faktureringsregelen du setter opp. Alle registreres og er klare til å sendes." },
    { q: "Hva skjer hvis en kunde ikke betaler?", a: "Centauros følger opp for deg: automatiske påminnelser, oppfølging av forfall og merking av manglende betaling, slik at du får inn det utestående uten ubehagelige samtaler." },
    { q: "Er Centauros trygt?", a: "Ja. Betalinger håndteres i sin helhet via Stripe, data sendes kryptert, og vi lagrer aldri kortopplysninger. Plattformen følger god sikkerhetspraksis." },
    { q: "I hvilke land er det tilgjengelig?", a: "Centauros er bygget for å fungere internasjonalt. Tilgjengelige betalingsmetoder avhenger av landene Stripe støtter, som dekker de fleste markeder i Europa, Amerika og andre regioner." },
    { q: "Hvordan kommer jeg i gang?", a: "Last ned appen, opprett kontoen din og sett opp din første betalingsregel på få minutter. Derfra kan du begynne å kreve inn og automatisere betalingene dine." },
  ],
  legalx: {
    eyebrow: "Juridisk", contents: "Innhold", questions: "Spørsmål om denne siden? Ta kontakt.",
    navPrivacy: "Personvern", navTerms: "Vilkår", navCookies: "Informasjonskapsler", navSupport: "Support",
    cookiesMetaTitle: "Retningslinjer for informasjonskapsler — Centauros", cookiesMetaDesc: "Hvordan Centauros bruker informasjonskapsler og lignende teknologier.",
  },
  product2: {
    p1title: "Slutt å jage. Begynn å få betalt.",
    p1sub: "Manuell oppfølging gjør at du taper penger. Med Centauros setter du retningslinjene og får betalt automatisk, uten ubehagelige samtaler.",
    p1cta: "Last ned Centauros",
    p1link: "Se hvordan det fungerer",
    p1cardTitle: "For hver 1 000 € fakturert",
    p1cardCol: "Får du faktisk",
    p1rows: [
      { name: "Centauros", amount: "1 000 €" },
      { name: "Manuelle påminnelser", amount: "910 €", delta: "−90 €" },
      { name: "Uten oppfølging", amount: "820 €", delta: "−180 €" },
    ],
    p2title: "Få betalt for arbeidet ditt, uten friksjon.",
    p2sub: "Betalingslenker, retningslinjer og automatiske fakturaer. Du setter reglene én gang, og Centauros gjør resten.",
    p2cta: "Se hvordan det fungerer",
    p2policy: "Retningslinje · Depositum + restbeløp",
    p2sendLabel: "Kunden betaler",
    p2client: "Kunde",
    p2info: "Gjentakende betaling? Sett det opp én gang, så trekkes det automatisk hver periode.",
    p2recipLabel: "Du mottar",
    p2you: "Deg",
    p2arrives: "Trukket",
    p2arrivesVal: "I dag · automatisk",
    p2fees: "Gebyrer",
    p2feesVal: "Inkludert",
    p3title: "Gjør mye mer med Centauros.",
    p3sub: "Det handler ikke bare om å få betalt: administrer kunder, fakturaer, ubetalte krav og teamet ditt fra ett sted.",
    p3cta: "Opprett konto",
    p3cardLabel: "Til innkreving",
    p3feat: "Få betalt umiddelbart",
    p3featDesc: "Betalingslenker og automatisk innkreving drevet av Stripes infrastruktur.",
    p3check: "Flere betalingsmetoder",
    p3cta2: "Utforsk innkrevinger",
    p4title: "Få tilbake de ubetalte kravene du hadde gitt opp.",
    p4sub: "Centauros purrer automatisk på forsinkede betalinger med påminnelser og nye forsøk, helt til du får betalt.",
    p4cta: "Se hvordan det fungerer",
    p4cardLabel: "Gjenvunne krav",
    p4foot: "Fagfolk gjenvinner i snitt 38 % flere ubetalte krav i løpet av de første 6 månedene.",
  },
  pricing: {
    label: "Priser",
    title: "Tydelige priser. Ingen overraskelser.",
    subtitle: "Du betaler bare når du får betalt. Stripe tar sitt gebyr for å behandle betalingen, og Centauros legger til 1 % for automatiseringen, innkrevingen og hele plattformen.",
    stripeTitle: "Stripe-gebyr",
    stripeDesc: "Stripe behandler betalingen trygt. Gebyret varierer etter land og betalingsmetode; eksempelet som vises gjelder europeiske kort.",
    centaurosTitle: "Centauros-gebyr",
    centaurosDesc: "1 % av beløpet for automatisering, oppfølging av innkreving og hele plattformen. Ingen skjulte månedlige gebyrer.",
    calcTitle: "Regn ut hva du mottar",
    invoiceAmount: "Fakturabeløp",
    stripeFee: "Stripe-gebyr",
    centaurosFee: "Centauros-gebyr (1 %)",
    received: "Fagpersonen mottar",
    note: "Stripes faktiske gebyr kan variere etter land og betalingsmetode. Beløpene som vises er et veiledende eksempel.",
  },
  cookie: {
    title: "Ditt personvern, ditt valg",
    intro: "Vi bruker informasjonskapsler for at Centauros skal fungere riktig, huske innstillingene dine og for anonymt å forstå hvordan nettstedet brukes. Du velger hva som aktiveres, og kan ombestemme deg når som helst.",
    required: "Alltid på",
    acceptAll: "Godta alle",
    rejectAll: "Avvis alle",
    save: "Lagre preferanser",
    reopen: "Innstillinger for informasjonskapsler",
    footnote: "Du kan endre samtykket ditt når som helst fra bunnteksten.",
    policyLink: "Retningslinjer for informasjonskapsler",
    categories: {
      necessary: { name: "Nødvendige", desc: "Avgjørende for at nettstedet skal fungere og være sikkert. De kan ikke slås av." },
      preferences: { name: "Preferanser", desc: "Husker innstillingene dine, som språk, for en mer behagelig opplevelse." },
      analytics: { name: "Analyse", desc: "Hjelper oss å forstå anonymt hvordan nettstedet brukes, slik at vi kan forbedre det." },
      marketing: { name: "Markedsføring", desc: "Gjør det mulig å vise mer relevant innhold og annonser, på og utenfor nettstedet." },
    },
  },
};
export default no;
